import { RouterModule, Routes } from '@angular/router';

import { NgModule } from '@angular/core';

export const authen: Routes = [
    {
        path: 'login',
        loadComponent: () =>
          import('../../authentication/login/login.component').then((m) => m.LoginComponent),
    },
    {
        path: 'sign-up',
        loadComponent: () =>
            import('../../authentication/sign-up/sign-up.component')
                .then(m => m.SignUpComponent)
    },
    {
        path: 'setup-password',
        loadComponent: () =>
            import('../../authentication/setup-password/setup-password.component')
                .then(m => m.SetupPasswordComponent)
    },
]
@NgModule({
    imports: [RouterModule.forRoot(authen, {
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'top',
      })],
    exports: [RouterModule]
})
export class AuthenticationsRoutingModule { }